export default __webpack_public_path__ + "static/media/close.c4e201bd.svg";